import React from 'react';
import { CRM_COLORS } from '../../theme/crmColors';
import { product_types, redirect_to_product_types } from '../../pages/paths';
import Authentication from '../auth/Authentication';
import { User } from '../../utils/types';
import { useSelector } from 'react-redux';
import { CustomReducerState } from '../../redux/reducers';
import ProductTypeList from './ProductTypeList/ProductTypeList';
import { Box } from '@material-ui/core';
import IntegratedHeader from '../header/IntegratedHeader';
import { useTranslate } from 'react-admin';

const ProductTypePage = () => {
    const userConnected: User | null = useSelector((state: CustomReducerState) => state.rikutec.users.userConnected);
    const translate = useTranslate();

    return (
        <Authentication redirectTo={redirect_to_product_types}>
            {userConnected && (
                <Box
                    style={{
                        height: '100vh',
                        display: 'grid',
                        gridTemplateRows: 'auto 1fr',
                        backgroundColor: CRM_COLORS.background,
                    }}
                >
                    <IntegratedHeader
                        currentPath={product_types}
                        eyebrow={translate('app.headers.eyebrow.reference')}
                        title={translate('app.headers.productType')}
                    />

                    <Box
                        style={{
                            overflowY: 'auto',
                            minHeight: 0,
                            height: '100%',
                        }}
                    >
                        <ProductTypeList />
                    </Box>
                </Box>
            )}
        </Authentication>
    );
};

export default ProductTypePage;
